import { render } from "./AdsList.vue?vue&type=template&id=6b0e4aa7"
import script from "./AdsList.vue?vue&type=script&lang=js"
export * from "./AdsList.vue?vue&type=script&lang=js"

import "./AdsList.vue?vue&type=style&index=0&id=6b0e4aa7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__